var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVeeva(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 60,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.847128 0 0 .847128 17.448749 -10.748771)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.052 36.524L11.668 59.647.23 36.524h3.953l7.525 15.117 7.465-15.117zM81.535 39.5h-3.752l-6.37 12.686-6.35-12.686H61.35l10.082 20.17zM52.417 55.794a6.68 6.68 0 0 1-6.45-5.041h16.285v-1.596a9.83 9.83 0 1 0-1.128 4.587h-3.9a6.65 6.65 0 0 1-4.807 2.056m0-13.28a6.68 6.68 0 0 1 6.417 5.04H45.967a6.68 6.68 0 0 1 6.45-5.028M100.23 49.2v-9.648h-3.205v2.424a9.84 9.84 0 0 0-13.707.385c-3.712 3.817-3.712 9.895 0 13.712a9.84 9.84 0 0 0 13.707.385v2.444h3.205V49.23m-9.842 6.657a6.64 6.64 0 0 1-6.636-6.6 6.64 6.64 0 0 1 6.561-6.674 6.64 6.64 0 0 1 6.711 6.523v.22a6.68 6.68 0 0 1-6.637 6.53m-59.8-.092a6.68 6.68 0 0 1-6.463-5.034h16.292v-1.602a9.83 9.83 0 0 0-19.382-2.363c-1.194 4.826 1.4 9.784 6.047 11.554s9.882-.207 12.2-4.604h-3.886a6.63 6.63 0 0 1-4.807 2.056m0-13.28a6.68 6.68 0 0 1 6.45 5.041H24.113a6.68 6.68 0 0 1 6.463-5.028",
    fill: "#ff9e16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.506 36.565l5.14 10.262 5.12-10.262s-10.262-.04-10.262 0z",
    fill: "#8a8a8d"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVeeva);
export default __webpack_public_path__ + "static/media/Veeva.3ee54c922cd050f1980b3dd67d0aef6c.svg";
export { ForwardRef as ReactComponent };